module.exports = __webpack_public_path__ + "static/img/logonew.ca732c61.ca732c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/logonew.ca732c61.png
// module id = g/9x
// module chunks = 44